import { logEvent } from "firebase/analytics";
import { AnalyticsEvent } from "./AnalyticsEvent";
import useAnalytics from "../../hooks/useAnalytics";

const LogAnalyticsEvent = (event: AnalyticsEvent): void => {
    logEvent(useAnalytics(), event.key, event.data);
};

export default LogAnalyticsEvent;
